<template>
  <ValidationProvider v-slot="{ errors }" :name="$attrs.name" :rules="rules">
    <div :style="hidden ? `display: none` : ``">
      <v-radio-group
        v-bind="{ ...$attrs }"
        :value="value"
        :error-messages="errors"
        :readonly="readonly"
        v-on="$listeners"
        @change="emit"
      >
        <template
          v-for="(_, scopedSlotName) in $scopedSlots"
          #[scopedSlotName]="slotData"
        >
          <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
          <slot :name="slotName" />
        </template>
      </v-radio-group>
    </div>
  </ValidationProvider>
</template>

<script>
import VonexFieldsMixin from '@/mixins/vonexfields.mixin';
export default {
  name: 'VonexRadio',
  mixins: [VonexFieldsMixin],
};
</script>
